import { useTranslation } from 'react-i18next';
import Typography from '@mui/material/Typography';

import { AlertDialog } from 'common/components/AlertDialog';
import { Button } from 'common/components/Button';

interface IProps {
    open: boolean;
    onClose(): void;
}

export const UserImportBlockedDialog = ({ open, onClose }: IProps) => {
    const [translate] = useTranslation();

    return (
        <AlertDialog
            actions={
                <Button color="inherit" variant="contained" onClick={onClose}>
                    {translate('close')}
                </Button>
            }
            open={open}
            title={translate('userImportBlockedDialog.title')}
            onClose={onClose}
        >
            <Typography>{translate('userImportBlockedDialog.text')}</Typography>
        </AlertDialog>
    );
};
